export async function editCustomerUseCase(customer_id, customer_data, customerRepostitory) {
    const result = await customerRepostitory.edit(customer_id, customer_data);

    const entity = new customerRepostitory.model(result.data);

    if (!entity.isValid()) {
        throw new Error("customer inválido");
    }

    return result;
}